<template>
    <v-tab-item>
        <v-skeleton-loader v-if="! enrollments" type="table-tbody"></v-skeleton-loader>

        <user-table
            v-else
            :enrollments="enrollments"
            @delete="deleteConfirmation"
            @reject="rejectConfirmation"
            @activate="activateConfirmation"
            withAction
        ></user-table>

        <confirmation-dialog
            v-model="activationDialog"
            @ok="activate"
            title="Aktifkan akun?"
            color="primary"
            okText="Aktifkan"
            :loading="buttonLoading"
        >
        </confirmation-dialog>

        <confirmation-dialog
            v-model="rejectionDialog"
            @ok="reject"
            title="Tolak akun?"
            color="warning"
            okText="Tolak"
            :loading="buttonLoading"
        >
        </confirmation-dialog>

        <confirmation-dialog
            v-model="deletionDialog"
            @ok="deleteEnrollment"
            title="Hapus akun?"
            subtitle="Aksi tidak dapat dibatalkan"
            color="error"
            okText="Hapus"
            :loading="buttonLoading"
        >
        </confirmation-dialog>
    </v-tab-item>
</template>

<script>
import ConfirmationDialog from './ConfirmationDialog'
import UserTable from './UserTable'

export default {
    components: {
        UserTable,
        ConfirmationDialog,
    },

    data() {
        return {
            enrollments: null,
            selectedEnrollmentId: null,
            activationDialog: false,
            rejectionDialog: false,
            deletionDialog: false,
            buttonLoading: false,
        }
    },

    methods: {
        activateConfirmation(enrollment_id) {
            this.selectedEnrollmentId = enrollment_id
            this.activationDialog = true
        },

        rejectConfirmation(enrollment_id) {
            this.selectedEnrollmentId = enrollment_id
            this.rejectionDialog = true
        },

        deleteConfirmation(enrollment_id) {
            this.selectedEnrollmentId = enrollment_id
            this.deletionDialog = true
        },

        activate() {
            this.buttonLoading = true

            this.$api.patch(`enrollment/${this.selectedEnrollmentId}/activate`)
                .then(response => {
                    this.buttonLoading = false

                    if (response.data.activated) {
                        this.activationDialog = false
                        this.getUserList()
                    }
                })
        },

        reject() {
            this.buttonLoading = true

            this.$api.patch(`enrollment/${this.selectedEnrollmentId}/reject`)
                .then(response => {
                    this.buttonLoading = false

                    if (response.data.rejected) {
                        this.rejectionDialog = false
                        this.getUserList()
                    }
                })
        },

        deleteEnrollment() {
            this.buttonLoading = true

            this.$api.delete(`enrollment/${this.selectedEnrollmentId}`)
                .then(response => {
                    this.buttonLoading = false

                    if (response.data.deleted) {
                        this.deletionDialog = false
                        this.getUserList()
                    }
                })
        },

        getUserList() {
            this.$api.get(`period/${this.$route.params.period_id}/user`, { loader: 'appbar' })
                .then(response => {
                    this.enrollments = response.data.enrollments
                })
        }
    },

    created() {
        this.getUserList()
    }
}
</script>
